import { render, staticRenderFns } from "./BaseTransactionDetailsCashback.vue?vue&type=template&id=75d50157&"
import script from "./BaseTransactionDetailsCashback.vue?vue&type=script&lang=js&"
export * from "./BaseTransactionDetailsCashback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports